import { useEffect } from "react";
import { useLocation } from "react-router";

/** /legal/* (M6 round seven): the legal pages are rendered by the API at the same address (a page that stands without the app: the
 *  mails, the bot page and the apex's redirect link it). The router names the path before /:workspace/*, so a signed-in person is
 *  never sent into a workspace called "legal"; a client-side navigation that lands here loads the server's page in full. */
export function LegalRedirect() {
  const { pathname } = useLocation();
  useEffect(() => { window.location.assign(pathname); }, [pathname]);
  return null;
}
